import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledInputContainer = styled.div`
  display: flex;
  padding: 1em;
  background-color: ${colours.Shades.TintBlue10};
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const StyledBreakdown = styled.div`
  padding: 1em;
  background-color: ${colours.Shades.TintBlue10};
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const StyledBreakdownRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledTotalContainer = styled(StyledBreakdownRow)`
  font-weight: bold;
`;

export const StyledLabel = styled.span`
  display: flex;
  width: 100%;
  font-size: 12px;
`;

export const StyledInputWrapper = styled.div`
  flex-grow: 1;
  flex-basis: 0;

  & + & {
    margin-left: 0.5em;
  }

  input {
    width: auto;
    height: 35px;
    font-size: 13px;

    @media (max-width: 1175px) {
      width: 80%;
    }

    &:disabled {
      border: 1px solid transparent;
      background: transparent;
      font-weight: bold;
      width: 85%;
    }
  }
`;

export const StyledCurrencyValue = styled.span`
  font-size: 13px;
  font-weight: bold;
  line-height: 3em;
`;

export const StyledFormFooter = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledButtonGroup = styled.div`
  button + button {
    margin-left: 15px;
  }
`;

export const StyledWarningMessage = styled.p`
  margin-left: 15px;
`;

export const StyledErrorMessage = styled.p`
  margin-top: 0;
  width: 100%;
  color: ${colours.Messaging.ErrorRed};
`;
